import { makeStyles } from '@material-ui/core/styles'

export const useKeyModificationWarningDialogStyles = makeStyles((theme) => ({
    conflictMessage: {
        marginBottom: theme.spacing(2),
        fontWeight: 500,
    },
    contextMessage: {
        marginBottom: theme.spacing(2),
    },
}))
